<template>
  <v-container>
    <v-row justify-center>
      <v-col>
        <v-card>
          <v-form ref="userForm" class="p-5">
            <!-- lastname -->
            <v-text-field
              v-model="profile.firstName"
              label="Nom"
              :rules="[rules.required, rules.counter]"
              counter
              maxlength="60"
            />

            <!-- firstname -->
            <v-text-field
              v-model="profile.lastName"
              label="Prénom"
              :rules="[rules.required, rules.counter]"
              counter
              maxlength="60"
            />

            <!-- email -->
            <v-text-field
              v-model="profile.email"
              label="E-mail"
              :rules="[rules.required, rules.validEmail]"
            />

            <!-- current password -->
            <v-text-field
              v-model="profile.currentPassword"
              label="Mot de passe actuel"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showPassword = !showPassword"
              hint="Laissez vide pour ne pas modifier le mot de passe"
              persistent-hint
            />

            <!-- new password -->
            <v-text-field
              v-model="profile.newPassword"
              label="Nouveau mot de passe"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showPassword = !showPassword"
              hint="Laissez vide pour ne pas modifier le mot de passe"
              persistent-hint
            />

            <!-- confirm new password -->
            <v-text-field
              v-model="profile.confirmPassword"
              label="Confirmation du nouveau mot de passe"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword ? 'text' : 'password'"
              name="input-10-1"
              @click:append="showPassword = !showPassword"
              :rules="[
                rules.confirmPassword(
                  profile.confirmPassword,
                  profile.newPassword
                ),
              ]"
            />

            <v-col align="center">
              <v-btn color="primary" class="mr-4" @click="submitForm(profile)">
                Valider
              </v-btn>
            </v-col>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AuthService from "@/services/AuthService";
import store from "@/store";
import { validate as isValidUUID } from "uuid";
import { updateUserAsync } from "@/api/accountApi";

export default {
  name: "Profile",

  data: () => ({
    profile: AuthService.identity,
    showPassword: false,
    rules: {
      required: (value) => !!value || "Requis.",
      counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
      validPassword: (value) =>
        value ? value.length >= 5 : "Min 5 caractères",
      confirmPassword: (confirm, password) => {
        if (confirm === password) {
          return true;
        } else {
          return "Les mots de passes doivent être identiques";
        }
      },
      validEmail: (value) =>
        !value ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
        "E-mail invalide",
    },
  }),

  methods: {
    //CREATE or UPDATE the user with form validation
    async submitForm(item) {
      var isFormValid = this.$refs.userForm.validate();

      // If the form is valid
      if (isFormValid) {

        var payload = {
          'id': item.id,
          'firstname': item.firstName,
          'lastname': item.lastName,
          'email': item.email,
          'roles': item.roles,
          'isEnabled': item.isEnabled
        };

        if(item.newPassword){
          payload.newPassword = item.newPassword;
          payload.currentPassword = item.currentPassword;
        }

        var result = await updateUserAsync(item.id, payload);

        // If we have a result in the result, the save succeeded
        if (result && (isValidUUID(result.id) || result.id > 0)) {
          store.dispatch("setSnackbar", {
            title: `Utilisateur mis à jour`,
            text: `L'utilisateur a bien été mis à jour.`,
            status: "success",
            timeout: 2000,
          });
        }

        //await AuthService.refreshToken();
      }
      // Else display form errors
      else {
        // handle missing firstname
        if (!item.firstName) {
          store.dispatch("setSnackbar", {
            title: "Prénom requis",
            text: "Veuillez renseigner le prénom.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle missing lastname
        if (!item.lastName) {
          store.dispatch("setSnackbar", {
            title: "Nom requis",
            text: "Veuillez renseigner le nom.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle missing email
        if (!item.email) {
          store.dispatch("setSnackbar", {
            title: "Email requis",
            text: "Veuillez renseigner l'email.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle wrong email
        if (
          item.email &&
          !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(item.email)
        ) {
          store.dispatch("setSnackbar", {
            title: "Email invalide",
            text: "Veuillez renseigner un email valide.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle  newPassword but no current password
        if (item.newPassword && !item.currentPassword) {
          store.dispatch("setSnackbar", {
            title: "Mot de passe actuel requis",
            text: "Veuillez renseigner votre mot de passe actuel.",
            status: "error",
            timeout: 2000,
          });
        }

        // handle wrong newPassword
        if (item.newPassword && item.newPassword.length < 5) {
          store.dispatch("setSnackbar", {
            title: "Nouveau mot de passe trop court",
            text: "Veuillez renseigner un nouveau mot de passe de plus de 5 caractères.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle password confirmation
        if (item.newPassword && !item.confirmPassword) {
          store.dispatch("setSnackbar", {
            title: "Mot de passe de confirmation requis",
            text: "Veuillez renseigner un mot de passe de confirmation.",
            status: "error",
            timeout: 2000,
          });
        }
        // handle password validation
        if (
          item.newPassword &&
          item.confirmPassword &&
          item.newPassword !== item.confirmPassword
        ) {
          store.dispatch("setSnackbar", {
            title: "Mots de passes différents",
            text: "Veuillez renseigner deux mots de passes identiques.",
            status: "error",
            timeout: 2000,
          });
        }
      }
    },
  },
};
</script>